module.exports = __webpack_public_path__ + "img/partner_icon14.63144d88.png";